import { useEffect, useRef } from 'react';
import { Spinner } from 'grommet';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLazyGetAuthMeQuery } from '../../api/authApi';
import { consumeAuthReturnTo } from '../../auth/authNavigation';
import { setAuthenticated } from '../../slices/authSlice';

export const AuthComplete = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const completionStarted = useRef(false);
  const [getAuthMe] = useLazyGetAuthMeQuery();

  useEffect(() => {
    if (completionStarted.current) {
      return;
    }

    completionStarted.current = true;

    getAuthMe()
      .unwrap()
      .then(() => {
        dispatch(setAuthenticated(true));
        navigate(consumeAuthReturnTo(), { replace: true });
      })
      .catch(() => {
        dispatch(setAuthenticated(false));
        consumeAuthReturnTo();
        navigate('/', { replace: true });
      });
  }, [dispatch, getAuthMe, navigate]);

  return <Spinner />;
};
